// Modál „Log změn“ — seznam změn aplikace seskupený po dnech (GET /api/changelog).
// Data načítá volající (LayoutMain), protože je potřebuje i pro tečku „nové“ u tlačítka.
import { ModalOverlay } from './ModalOverlay'

const TYPE_BADGES = {
  new:      { label: 'New',      cls: 'bg-green-100 text-green-700' },
  improved: { label: 'Improved', cls: 'bg-blue-100 text-blue-700' },
  fixed:    { label: 'Fixed',    cls: 'bg-amber-100 text-amber-700' },
}

// 'YYYY-MM-DD' → '17. 9. 2026' bez převodu přes Date (žádný posun časovou zónou).
function formatDate(iso) {
  const [y, m, d] = iso.split('-')
  return `${Number(d)}. ${Number(m)}. ${y}`
}

export function ChangelogModal({ entries, onClose }) {
  return (
    <ModalOverlay onClose={onClose} className="z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-800">Log změn</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl leading-none px-1"
            title="Zavřít"
          >
            ×
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-4 flex flex-col gap-5">
          {entries.length === 0 && (
            <p className="text-sm text-gray-400">Žádné záznamy.</p>
          )}
          {entries.map(entry => (
            <section key={entry.date}>
              <h3 className="text-sm font-semibold text-gray-500 mb-2">{formatDate(entry.date)}</h3>
              <ul className="flex flex-col gap-1.5">
                {entry.items.map((item, i) => {
                  const badge = TYPE_BADGES[item.type]
                  return (
                    <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                      <span
                        className={`shrink-0 w-18 text-center text-[11px] font-semibold rounded px-1.5 py-0.5 mt-px ${badge?.cls ?? 'bg-gray-100 text-gray-500'}`}
                      >
                        {badge?.label ?? 'Other'}
                      </span>
                      <span>{item.text}</span>
                    </li>
                  )
                })}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </ModalOverlay>
  )
}
